module.exports = __webpack_public_path__ + "static/media/overview.e4c8584f.svg";